import React from "react";
import { IPlayerSearchResponse } from "../../../types/IPlayerSearchResponse";
import CustomList from "../../../ui/CustomList";
import ClubItem from "./ClubItem";
import { useClubSearch } from "../../../contexts/ClubSearchContext";

interface ISearchClubProps {
  searchData: any[];
  searchText: string;
  onSelect?: (item: IPlayerSearchResponse | IPlayerSearchResponse[] | null, selected: boolean) => void;
  selectedItems?: IPlayerSearchResponse[];
  multiSelection?: boolean;
  iconType: string;
  displayCheckBox?: boolean;
  handleTeamChange?: (team: string, teamId: string) => void;
  isMaxWidth?: boolean;
  isForCompareTeamASrchtype?:boolean
}

const ClubSearchList: React.FC<ISearchClubProps> = ({
  searchData,
  searchText,
  onSelect,
  selectedItems,
  multiSelection,
  iconType,
  displayCheckBox,
  handleTeamChange,
  isMaxWidth = true,
  isForCompareTeamASrchtype
}) => {
  
  return (
    <CustomList<IPlayerSearchResponse>
      selectedItems={selectedItems}
      onSelect={onSelect}
      multiSelection={multiSelection}
      isCheckBox={displayCheckBox}
      showSelectAllCheckbox={false}
      isMaxWidth={isMaxWidth}
    >
      {searchData.map((club) => {
        return <ClubItem key={club.id} item={club} searchText={searchText} iconType={iconType} handleTeamChange={handleTeamChange} isForCompareTeamASrchtype={isForCompareTeamASrchtype}/>;
      })}
    </CustomList>
  );
};

export default ClubSearchList;
